// src/components/common/ScrollToTop.jsx
//
// A browser resets scroll on every page load; a single-page app does not —
// React Router swaps the component but leaves the window where it was. So
// scrolling halfway down the dashboard and then opening Physical Products
// landed you halfway down THAT page too, with no way to tell what you'd
// missed above.
//
// Two deliberate exceptions:
//   - Only `pathname` is watched, not the whole location. Pages that keep
//     state in the query string (e.g. the admin payouts tab, ?tab=manual)
//     would otherwise jump to the top on every tab click.
//   - A URL with a #hash is left alone, so anchor links still land on their
//     target instead of being yanked back to the top.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // 'instant' — a smooth scroll on navigation reads as the new page
    // sliding around while it mounts.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
